import React, { useState, useEffect } from "react";
import Modal from "~components/Modal";
import PolyvLiveStream from "~components/PolyvLiveStream";
import PolyvVideo from "~components/PolyvVideo";
import { SVG_LIBRARY } from "~components/Svg";
import LiveStreamNotification from "~components/LiveStreamNotification";

import styles from "./index.module.scss";

const VideoPlayer = (props) => {
  const { video, play, onClose } = props;
  const videoType = video.type;
  // Force child component to refresh
  const [videoKey, setVideoKey] = useState(0);
  const [displayPortraitNote, setDisplayPortraitNote] = useState(true);

  useEffect(() => {
    const handleOrientationChange = () => {
      setVideoKey(+new Date());
    };

    window.addEventListener("orientationchange", handleOrientationChange);

    return () => {
      window.removeEventListener("orientationchange", handleOrientationChange);
    };
  }, []);

  return (
    <Modal active={play} className={styles.VideoPlayer} onClose={onClose}>
      {videoType === "polyvlive" && (
        <div className={styles.VideoPlayerInner}>
          <div className={styles.VideoPlayerInnerWrapper}>
            {displayPortraitNote && video.portraitNote && (
              <div className={styles.VideoPlayerTips}>
                <i
                  className={styles.LiveStreamNotificationCloseIcon}
                  onClick={() => setDisplayPortraitNote(false)}
                >
                  {SVG_LIBRARY["iconClose"]}
                </i>
                {video.portraitNote}
              </div>
            )}
            <PolyvLiveStream
              key={videoKey}
              {...video}
              className={styles.VideoPlayer}
            />
          </div>
          {video.notification?.active && (
            <LiveStreamNotification data={video.notification} />
          )}
        </div>
      )}
      {videoType === "polyv" && (
        <PolyvVideo {...video} className={styles.VideoPlayer} />
      )}
      {(videoType === "video/mp4" || videoType === "video/webm") && (
        <video
          autoPlay
          muted
          preload="true"
          controls
          className={styles.VideoPlayer}
        >
          <source src={video.source} type={videoType} />
        </video>
      )}
    </Modal>
  );
};

export default VideoPlayer;
